import React from 'react';
import { Globe } from 'lucide-react';
import { useLanguage, Language } from '../contexts/LanguageContext';
export function LanguageSwitch() {
  const {
    language,
    setLanguage
  } = useLanguage();
  return <div className="flex items-center gap-2 bg-gray-100 rounded-lg p-1" data-id="element-154">
      <Globe className="w-4 h-4 text-gray-600 ml-2" data-id="element-155" />
      <button onClick={() => setLanguage('fr')} className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${language === 'fr' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-156">
        FR
      </button>
      <button onClick={() => setLanguage('en')} className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${language === 'en' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-157">
        EN
      </button>
    </div>;
}